<section
  class="theme-prompt"
  role="dialog"
  aria-modal="false"
  aria-labelledby="first-run-theme-title"
  aria-describedby="first-run-theme-description"
  [attr.aria-busy]="isSaving">
  <ion-button
    class="theme-prompt__close"
    type="button"
    fill="clear"
    size="small"
    aria-label="Dismiss theme preference and use System theme"
    [disabled]="isSaving"
    (click)="dismiss()"
    data-testid="first-run-theme-close">
    <ion-icon slot="icon-only" name="close-outline" aria-hidden="true"></ion-icon>
  </ion-button>

  <div class="theme-prompt__copy">
    <h2 id="first-run-theme-title">Make Solo comfortable for you</h2>
    <p id="first-run-theme-description">
      Choose a theme to preview it now. You can change this later in Theme &amp; Display.
    </p>
  </div>

  <ion-segment
    class="theme-prompt__options"
    [value]="selectedMode"
    [disabled]="isSaving"
    aria-label="Choose a theme"
    (ionChange)="onThemeChange($event)"
    data-testid="first-run-theme-options">
    @for (option of themeOptions; track option) {
      <ion-segment-button
        [value]="option.mode"
        [attr.aria-label]="option.label + ': ' + option.description"
        [attr.data-testid]="'first-run-theme-' + option.mode">
        <ion-icon [name]="option.icon" aria-hidden="true"></ion-icon>
        <ion-label>
          <span class="theme-prompt__option-label">{{ option.label }}</span>
          <span class="theme-prompt__option-description">{{ option.description }}</span>
        </ion-label>
      </ion-segment-button>
    }
  </ion-segment>

  <span class="visually-hidden" aria-live="polite">{{ previewAnnouncement }}</span>
  @if (saveError) {
    <p class="theme-prompt__error" role="alert">{{ saveError }}</p>
  }

  <div class="theme-prompt__actions">
    <ion-button
      type="button"
      fill="clear"
      color="medium"
      [disabled]="isSaving"
      (click)="dismiss()"
      data-testid="first-run-theme-dismiss">
      Not now
    </ion-button>
    <ion-button
      type="button"
      [disabled]="isSaving"
      (click)="save()"
      data-testid="first-run-theme-save">
      @if (isSaving) {
        <ion-spinner slot="start" name="crescent" aria-hidden="true"></ion-spinner>
      }
      @if (!isSaving) {
        <ion-icon slot="start" name="save-outline" aria-hidden="true"></ion-icon>
      }
      {{ isSaving ? 'Saving' : 'Save theme' }}
    </ion-button>
  </div>
</section>
